import React from "react";
import styles from "./../../assets/styles/_breadcrumb.module.scss";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({ data }) => {
  const navigate = useNavigate();
  function handleClick(link) {
    navigate(link);
    window.scrollTo(0, 0);
  }
  return (
    <div className={styles.breadcrumb}>
      {data?.map((item, index) => {
        return (
          <>
            <span
              key={index}
              onClick={() => handleClick(item.link)}
              className={styles.linkBreadcrumb}
            >
              {item.title}
            </span>
            {index !== data?.length - 1 && (
              <div className={styles.breadcrumbLine}></div>
            )}
          </>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
